export const historyRoutes = {
  internal: {
    getLeadHistory: '/internal/leads/:id/history',
    getSaleHistory: '/internal/sales/:id/history',
    getAppointmentHistory: '/internal/appointments/:id/history',
    getContractorHistory: '/internal/contractors/:id/history',
    getSaleCrmHistory: '/internal/sales/:id/crm-history',
    getLeadCrmHistory: '/internal/leads/:id/crm-history',
    getCampaignHistory: '/internal/campaigns/:id/history',
    getGroupHistory: '/internal/campaign-groups/:id/history',
    getInvoiceHistory: '/internal/invoices/:id/history',
  },
};
